module.exports = __webpack_public_path__ + "static/media/image 2.e815fa47.jpg";